import { createSnapshotTracker, describeBlocksChange, describeExercisesChange, resetHistory } from '@/utils/History'

export const EDITOR_HISTORY = 'editor'

export default {
    data() {
        return {
            historyRev: 0,
        }
    },
    beforeDestroy() {
        this.stopEditorHistory()
    },
    methods: {
        startEditorHistory(field) {
            const vm = this
            vm.stopEditorHistory()
            vm._historyTracker = createSnapshotTracker({
                context: EDITOR_HISTORY,
                read: () => vm[field],
                write: value => {
                    vm[field] = value
                    vm.historyRev++
                },
                describe: field === 'exercises' ? describeExercisesChange : describeBlocksChange,
            })
            vm._historyUnwatch = vm.$watch(field, () => vm._historyTracker && vm._historyTracker.schedule(), { deep: true })
        },
        stopEditorHistory() {
            const vm = this
            if (vm._historyUnwatch) vm._historyUnwatch()
            if (vm._historyTracker) vm._historyTracker.destroy()
            vm._historyUnwatch = null
            vm._historyTracker = null
            resetHistory(EDITOR_HISTORY)
        },
    },
}
